import { render, staticRenderFns } from "./OrganisationIndividualEdit.vue?vue&type=template&id=56cd816d&"
import script from "./OrganisationIndividualEdit.vue?vue&type=script&lang=ts&"
export * from "./OrganisationIndividualEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56cd816d')) {
      api.createRecord('56cd816d', component.options)
    } else {
      api.reload('56cd816d', component.options)
    }
    module.hot.accept("./OrganisationIndividualEdit.vue?vue&type=template&id=56cd816d&", function () {
      api.rerender('56cd816d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/OrganisationIndividualEdit.vue"
export default component.exports